import React, {MouseEvent} from "react";
import {createPortal} from "react-dom";
import ContentBox from "../content-box/ContentBox";
import './Modal.scss';

interface ModalProps {
    isOpen: boolean;
    onClose: () => void;
    children: React.ReactNode;
}

const Modal = (props: ModalProps) => {
    if (!props.isOpen) return null;

    const handleOverlayClick = (e: MouseEvent<HTMLDivElement>) => {
        if (e.target === e.currentTarget) {
            props.onClose();
        }
    };

    const modalContent = (
        <div className="modal-overlay" onClick={handleOverlayClick}>
            <ContentBox className="modal-content">
                <>
                    <div className="modal-close-button">
                        <button onClick={props.onClose}>&times;</button>
                    </div>
                    <div className="modal-scrollable-content">
                        {props.children}
                    </div>
                </>
            </ContentBox>
        </div>
    );

    return createPortal(modalContent, document.body);
};

export default Modal;
